import { useTranslation } from 'react-i18next';
import { Icon } from '@/components/common/Icon';

export function ReadOnlyNotice() {
  const { t } = useTranslation('assistant');
  return (
    <p className="flex items-center gap-2 px-3.5 py-2.5 bg-zoovpalelavender rounded-xl text-xs font-medium text-zooindigo">
      <Icon name="Lock" className="shrink-0" />
      {t('configuration.readOnlyNotice')}
    </p>
  );
}
